import {
  DB_CLIENT_NOTES,
  DB_CURR_NOTE,
} from "constants/ActionTypes"

const INIT_STATE = {
  db_client_notes: null,
  db_client_note: null,
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {

    case DB_CLIENT_NOTES: {
      return {
        ...state,
        db_client_notes: action.payload.notes
      }
    }

    case DB_CURR_NOTE: {
      return {
        ...state,
        db_client_note: action.payload
      }
    }

    default:
      return state;
  }
}